import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'

// Root cache keys for every declaration domain, cleared when the editor mounts so a
// freshly opened declaration never shows another declaration's stale cached data.
// These values must stay in sync with the query keys each domain's api layer uses.
const declarationCacheRootKeys = [
  '/v2/additional-information',
  '/v2/additional-reference',
  '/v2/authorisation',
  '/v2/consignment-detail/carrier',
  '/v2/consignment',
  '/v2/consignment-detail',
  '/v2/consignment-item',
  '/v2/customs-office/transit',
  '/v2/document',
  '/v2/document-file',
  '/v2/directo-event',
  '/v2/house-consignment',
  '/v2/seal',
  '/v2/transit-operation',
  '/v2/transit-operation-audit',
  'v2/transit-operation-log',
  '/v2/transit-operation-info',
  '/v2/transport-equipment',
  '/v1/ncts-profile',
  '/v2/guarantee',
  '/v2/guarantee-calculation',
  'v3/consignment',
  'v3/house-consignment',
  'v3/house-consignment/list',
  'consignment-item',
] as const

function useClearQueryCache() {
  const queryClient = useQueryClient()
  useEffect(() => {
    declarationCacheRootKeys.forEach((key) => queryClient.removeQueries({ queryKey: [key] }))
  }, [queryClient])
}

export default useClearQueryCache
